// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    agentsTextCodeReviewer: "Code Reviewer ",
    agentsTextIncidentResolver: "Incident Resolver",
    agentsTextPmoAgent: "PMO Agent",
    agentsTextRiskAnalyzer: "Risk Analyzer",
    agentsTextSalesAgent: "Sales Agent",
    agentsTextTranslatorAgent: "Translator Agent",
    boardCrmImage: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69723acb66e4e8db583e0fc1_hero-crm-image-2.avif",
        alt: ""
    },
    boardDefault: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69709144446a911974ee5317_hp-26-hero-default-1.avif",
        alt: ""
    },
    boardItImage: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970f8adbfb2a9f516ed129d_hero-service-image.avif",
        alt: ""
    },
    boardMarketingImage: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970f8aee6199cb4f9e39741_hero-marketing-image.avif",
        alt: ""
    },
    boardSoftwareImage: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970f8aef441f3b4b5fb9c77_hero-dev-image.avif",
        alt: ""
    },
    buttonSmallText: "No credit card needed ✦ Unlimited time on Free plan <br />",
    crmFloatingImage1: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970b5efa03aa9065fd81bc3_crm-sidekick-image.png",
        alt: ""
    },
    crmFloatingImage2: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970e23b51ea267bc92d0980_crm-agent-image.png",
        alt: ""
    },
    crmTextImportMyContacts: "Import my contacts",
    crmTextLeadAgent: "Lead Agent",
    crmTextMeetingSummarizer: "Meeting Summarizer",
    crmTextRepPerformanceRanker: "Rep performance ranker",
    defaultBoardWidgetFloating1: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/697f541855ac4fdee6f77e40_agent-blur-1-fu.png",
        alt: ""
    },
    defaultBoardWidgetFloating2: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/697f5418cfc366a5bf592ce1_agent-blur-2-fu.png",
        alt: ""
    },
    headingBlack: "Outpace everyone with the ",
    headingGradient: "best AI work platform",
    itFloatingImage1: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970b908b04f88efb7ba7f3d_it-sidekick-image.png",
        alt: ""
    },
    itFloatingImage2: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970b90985757386f07bff61_it-agent-image.png",
        alt: ""
    },
    itTextIncidentResolver: "Incident Resolver",
    itTextMonitorSlasAndRisks: "Monitor SLAs and risks",
    itTextSlaMonitoringAgent: "SLA Monitoring Agent",
    itTextSummarizeTicketHistory: "Summarize ticket history",
    marketingFloatingImage1: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970b746c4aa91672c3b0301_marketing-sidekick-image.png",
        alt: ""
    },
    marketingFloatingImage2: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970b746ee23e23fe1b233ea_marketing-agent-image.png",
        alt: ""
    },
    marketingTextCraftCopyForAds: "Craft copy for ads",
    marketingTextGenerateBrandAssets: "Generate brand assets",
    marketingTextRsvpAgent: "RSVP Agent",
    marketingTextTranslatorAgent: "Translator Agent",
    pickerAiAgents: "AI <br /> Agents",
    pickerAiAppBuilder: "AI <br /> App builder",
    pickerAiAssistant: "AI <br /> Assistant",
    pickerAiWorkflows: "AI <br /> Workflows",
    pickerButtonText: "Get Started",
    pickerCrm: "CRM",
    pickerIt: "IT",
    pickerMarketing: "Marketing",
    pickerProjectsTasks: "Projects & Tasks",
    pickerSoftware: "Software",
    primaryButtonText: "Get Started",
    projectsBoardImage: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970f8ae9f565f4e63deb043_hero-projects-image.avif",
        alt: ""
    },
    projectsFloatingImage1: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970adf42172e2858f585428_projects-sidekick-image.png",
        alt: ""
    },
    projectsFloatingImage2: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970ae3bdd4785d8f8c7d7cb_projects-agent-image.png",
        alt: ""
    },
    projectsTextCreateAProjectPlan: "Create a project plan",
    projectsTextPmoAgent: "PMO Agent",
    projectsTextRiskAnalyzer: "Risk analyzer agent",
    projectsTextSpotBottlenecks: "Spot bottlenecks",
    sectionSubtitle: "Exponential execution that scales your business impact and expands what your teams can deliver.",
    sidekickFloatingAnalyzingData: "Analyzing data",
    sidekickFloatingBrainstormingIdeas: "Brainstorming ideas",
    sidekickFloatingCreatingBoard: "Creating board",
    sidekickFloatingGeneratingImage: "Generating image",
    sidekickFloatingResearchingOnline: "Researching online",
    sidekickFloatingWritingDoc: "Writing doc",
    softwareFloatingImage1: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970ba3f7af39621726ee87d_software-sidekick-image.png",
        alt: ""
    },
    softwareFloatingImage2: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970ba3adbf5db52c6e13623_software-agent-image.png",
        alt: ""
    },
    softwareTextBuildRoadmapPlan: "Build roadmap plan",
    softwareTextGetRiskSnapshot: "Get risk snapshot",
    softwareTextPrdAgent: "PRD Agent",
    softwareTextSentimentDetector: "Sentiment Detector Agent",
    textWhatWouldYouLikeToExplore: "What would you like to explore?",
    vibeFloatingBugTracker: "Bug tracker",
    vibeFloatingCommissionCalculator: "Commission calculator",
    vibeFloatingContentCalendar: "Content calendar",
    vibeFloatingEventPlanner: "Event planner",
    vibeFloatingOnboardingFlow: "Onboarding flow",
    vibeFloatingProjectTracker: "Project tracker",
    workflowsFloatingImageLeft: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970a9db3cac6b6ee801e6bb_workflows-widget-left-image.png",
        alt: ""
    },
    workflowsFloatingImageRight: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6970a59690b7c3184f78aa02_workflows-widget-right-image.png",
        alt: ""
    }
};
